import { AppStateType } from '@lib/core/service/types/appStateType';

export const selectProductSetsIsFetching = (state: AppStateType, defaultValue = false): boolean =>
  state.productsRoot.productSets.isProductSetsLoading || defaultValue;

export const selectProductSetProducts = (state: AppStateType, defaultValue = []) =>
  state.productsRoot.productSets.productSetProducts || defaultValue;

export const selectProductSetsIds = (state: AppStateType, defaultValue = []) =>
  state.productsRoot.productSets.productSetsIds || defaultValue;

export const selectProductSetsImages = (state: AppStateType, defaultValue = []) =>
  state.productsRoot.productSets.productSetsImages || defaultValue;

export const selectProductSetsProductListIsFetching = (state: AppStateType, defaultValue = null) =>
  state.productsRoot.productSets.isProductSetProductsLoading || defaultValue;
